import { put } from 'redux-saga/effects';
import { push } from 'react-router-redux';
//import { delay } from 'redux-saga';

import store from '../store';
import * as endpoint from 'misc/endpoint';
import * as types from 'misc/types';
import { isCorrectContentType } from 'misc/helpers';

export function* getEnvelopeContents(action) {
    try {
        if(action.view === 'inbox'){
            let envelopes_inbox = store.getState().envelopes_inbox;
            
            if(!envelopes_inbox.data){
                yield put(push('/inbox'));
            }

            // Set envelope as read
            let envelopeToRead = envelopes_inbox.data.find(e => e.id === action.envelopeId);
            envelopeToRead.state.read = true;
            yield endpoint.put('envelopes/' + action.envelopeId, { state: envelopeToRead.state });
    
            yield put({ type: types.SAGA_ENVELOPES_INBOX_GET.SUCCESS, payload: envelopes_inbox.data });
        }
        
        // Load contents
        const response = yield endpoint.get('envelopes/' + action.envelopeId + '/contents');

        let envelope_contents = [];

        let ordered_contents = response.data;
        ordered_contents.sort(function(a, b) {
            return a.order - b.order;
        });

        ordered_contents.forEach(function(envelope_content) {
            // Add key attribute to envelope_contents
            envelope_content.key = envelope_content.id;
            envelope_content.envelopeId = action.envelopeId;
            envelope_contents.push(envelope_content);
        });

        // Only show specific document types inline
        const first_content = { ...envelope_contents[0] };

        if (first_content.presentationType === types.PRESENTATION_TYPES.INLINE) {
            // Check if correct inline type
            if (isCorrectContentType(first_content.contentType, [types.CONTENT_TYPES.TEXT, types.CONTENT_TYPES.HTML, types.CONTENT_TYPES.PDF])) {
                // Safari fix for pdf
                if (first_content.contentType === 'application/pdf;charset=UTF-8') {
                    first_content.contentType = 'application/pdf';
                }
                
                // Get body of first content
                if(first_content.contentType === types.CONTENT_TYPES.TEXT){
                    // If text content get actual byte array to show
                    yield put({
                        type: types.SAGA_ENVELOPE_CONTENT_INLINE_GET.REQUEST,
                        customerId: action.customerId,
                        contentInfo: first_content,
                        inline: true
                    }); 
                }else {
                    // if html and pdf, just save the url info for embed
                    yield put({
                        type: types.SAGA_ENVELOPE_CONTENT_INLINE_GET.SUCCESS,
                        payload: first_content
                    });
                }
                
                // Remove inline content from envelope_contents
                envelope_contents.shift();
            }
        }

        yield put({ type: types.SAGA_ENVELOPE_CONTENTS_GET.SUCCESS, payload: envelope_contents });
    } catch (error) {
        yield put({ type: types.SAGA_ENVELOPE_CONTENTS_GET.FAILURE, error });
    }
}


// WEBPACK FOOTER //
// ./src/sagas/envelope_contents.js